import * as React from 'react';
import { Globe, Menu } from 'lucide-react';
import { Box } from 'src/ui/box';
import { Button } from 'src/ui/button';
import { Drawer, DrawerContent } from 'src/ui/drawer';
import { Typography } from 'src/ui/typography';

export default function MobileNav({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const closeDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setIsOpen(false);
  };

  return (
    <Box className="block md:hidden">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        lowercase
        aria-label="Open sales packet menu"
        className="hover:bg-white/10 [&_svg]:h-6 [&_svg]:w-6"
        onClick={() => setIsOpen(true)}
      >
        <Menu className="ml-10 block text-white md:hidden" />
      </Button>
      <Drawer open={isOpen} onClose={() => setIsOpen(false)} direction="left">
        <DrawerContent
          direction="left"
          size={250}
          handle={false}
          title="Sales Packet"
          description="Sales packet navigation"
          className="w-[250px]"
        >
          <Box
            className="flex w-[250px] flex-col justify-center"
            role="presentation"
            onClick={closeDrawer}
            onKeyDown={closeDrawer}
          >
            <Typography variant="h6" className="mt-10 text-center">
              <Globe className="h-9 w-9" /> Sales Packet
            </Typography>
            <div className="p-10">{children}</div>
          </Box>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}
